import cx from "classnames";
import React, { FC } from "react";
import { BsChevronDown } from "react-icons/bs";
import CtaButton from "./CtaButton";
import NavIntegrationMenu from "./new-ui/new-header/NavIntegrationMenu";
import NavKnowledgeHubMenu from "./new-ui/new-header/NavKnowledgeHubMenu";
import NavPartnerMenu from "./new-ui/new-header/NavPartnerMenu";
import NavProductMenu from "./new-ui/new-header/NavProductMenu";
import NavSolutionMenu from "./new-ui/new-header/NavSolutionMenu";
interface UnknownNavBarProps {
    handleLogin: (e: any) => void;
    open: boolean;
    showBanner?: boolean;
    isFreezone?: boolean;
    isArabic?: boolean;
}

export interface FeatureInfo {
    title?: string;
    summary?: string;
    link?: string;
    label?: string;
    image?: string;
    imgAlt?: string;
    height?: number;
    width?: number;
}
export interface NavMenuProps {
    featureTitle: string;
    feature: FeatureInfo[];
}
const webAppUrl = process.env.NEXT_PUBLIC_GB_APP_PUBLIC_URL;

const UnknownNavBar: FC<UnknownNavBarProps> = ({ open, showBanner, isFreezone, isArabic }) => {
    const itemsClassName = "lg:text-gray-600 text-black cursor-pointer my-6 md:mr-3 md:my-0 lg:font-normal font-medium";
    return (
        <nav
            className={cx(
                "flex-col md:flex-row flex-grow text-base md:text-sm items-start md:items-center pb-4 md:pb-0 px-4 md:px-0 md:flex md:justify-between shadow-lg md:shadow-none rounded-b-lg md:rounded-b-none nav hidden",
                { flex: open, hidden: !open }
            )}
        >
            <ul className="nav__menu flex ">
                <li className="nav__menu-item">
                    <p className={`${itemsClassName} flex items-center`}>
                        {" "}
                        Product
                        <BsChevronDown className="ml-1 nav-arrow" />{" "}
                    </p>
                    <div
                        className={cx("nav__submenu navbar__submenu_wrapper", {
                            "submenu--with-banner": showBanner,
                        })}
                    >
                        <div style={{ marginTop: "29px" }}>
                            <NavProductMenu />
                        </div>
                    </div>
                </li>

                <li className="nav__menu-item">
                    <p className={`${itemsClassName} flex items-center`}>
                        {" "}
                        Solutions
                        <BsChevronDown className="ml-1  nav-arrow" />{" "}
                    </p>

                    <div
                        className={cx("nav__submenu navbar__submenu_wrapper", {
                            "submenu--with-banner": showBanner,
                        })}
                    >
                        <div style={{ marginTop: "29px" }}>
                            {" "}
                            <NavSolutionMenu />
                        </div>
                    </div>
                </li>

                <li className="nav__menu-item">
                    <p className={`${itemsClassName} flex items-center`}>
                        {" "}
                        Integration
                        <BsChevronDown className="ml-1  nav-arrow" />{" "}
                    </p>

                    <div
                        className={cx("nav__submenu navbar__submenu_wrapper", {
                            "submenu--with-banner": showBanner,
                        })}
                    >
                        <div style={{ marginTop: "29px" }}>
                            <NavIntegrationMenu />
                        </div>
                    </div>
                </li>

                <li className="nav__menu-item ">
                    <p className={`${itemsClassName} flex items-center`}>
                        {" "}
                        Knowledge hub
                        <BsChevronDown className="ml-1  nav-arrow" />{" "}
                    </p>

                    <div
                        className={cx("nav__submenu navbar__submenu_wrapper", {
                            "submenu--with-banner": showBanner,
                        })}
                    >
                        <div style={{ marginTop: "29px" }}>
                            <NavKnowledgeHubMenu />
                        </div>
                    </div>
                </li>
                <li className="nav__menu-item ">
                    <p className={`${itemsClassName} flex items-center`}>
                        {" "}
                        Partners
                        <BsChevronDown className="ml-1  nav-arrow" />{" "}
                    </p>

                    <div
                        className={cx("nav__submenu navbar__submenu_wrapper", {
                            "submenu--with-banner": showBanner,
                        })}
                    >
                        <div style={{ marginTop: "29px" }}>
                            <NavPartnerMenu />
                        </div>
                    </div>
                </li>
            </ul>

            <div className="flex items-center">
                <a href={isArabic ? "#plan" : "/pricing"} className={itemsClassName}>
                    Pricing
                </a>
                <a href={`${webAppUrl ?? "https://app.gallabox.com"}/login`} target="_blank" rel="noreferrer" className="hover:no-underline">
                    Login{" "}
                </a>

                <CtaButton type="small" text={"Start free trial"} customClass={"ml-5 start-trial-btn"} href={isFreezone ? "#spc-form" : ""} target={isFreezone ? "_self" : ""} />
            </div>
        </nav>
    );
};

export default React.memo(UnknownNavBar);
